import { render, staticRenderFns } from "./OutlinedBlockBtn.vue?vue&type=template&id=54fd0efa"
import script from "./OutlinedBlockBtn.vue?vue&type=script&lang=ts"
export * from "./OutlinedBlockBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports